import Vue from "vue"
import Vuex from "vuex"

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        projectTags: [],  //标签数据
        projectTagsTrue: true, // 记录标签数据的变化
        switchTags: true, //标签显示隐藏
        defaultActive: '',  //当前激活菜单
        indexHome: false,  //左边菜单栏显示隐藏
        searchCondition: false,  //搜索条件显示隐藏
        tableWidth: false, //表格宽度
        toMaintainSKU: false, // 跳转到生物样本管理
    },
    mutations: {
        // 保存标签
        saveDbSource(state, DbSource) {
            state.projectTags.push(DbSource);
        },
        // 删除
        delTag(state, delTag) {
            state.projectTags.forEach((item, i) => {
                if (item.path.indexOf(delTag.path) != -1) {
                    state.projectTags.splice(i, 1)
                }
            })
        },
        //添加搜索数据
        addTagList(state, addList) {
            state.projectTags.forEach((item, i) => {
                if (item.path.indexOf(addList.router) != -1) {
                    item.list = addList
                    state.projectTagsTrue = false
                }
            })
        },
        //监听标签
        trueFalseTag(state, val) {
            state.projectTagsTrue = val
        },
        //删除标签
        delTags(state) {
            state.projectTags = [];
        },
        //当前激活菜单
        activationIndex(state, index) {
            state.defaultActive = index
        },
        //标签显示隐藏
        switchTagsClick(state, index) {
            state.switchTags = index
        },
        //搜索条件显示隐藏
        searchConditionClick(state, index) {
            state.searchCondition = index
        },
        //左边菜单栏显示隐藏
        indexHomeClick(state, index) {
            state.indexHome = index
        },
        // 表格宽度拖拽最小宽度
        handleHeaderDragend(__, [newWidth, oldWidth, column, event]) {
            if (newWidth < column.minWidth) {
                column.width = column.minWidth; // 表头最小宽度
                column.realWidth = column.minWidth; // 列内容最小宽度
            }
        },
        setTableWidth(state, val) {
            state.tableWidth = val
        },
        getToMaintainSKU(state, val) {
            state.toMaintainSKU = val;
        },
    }
})


// WEBPACK FOOTER //
// ./src/store/index.js